import { IEmail } from "@/types/common";
import BaseTable, { BaseTableColumn, FieldData } from "../../components/tables/BaseTable";
import React from "react";

const UnprocessedEmailsTable = ({
  unprocessedEmails,
  pagination,
  setPagination,
  totalCount,
  loading,
}: {
  unprocessedEmails: IEmail[];
  pagination: { page: number; limit: number; };
  setPagination: (pagination: { page: number; limit: number ;}) => void;
  totalCount: number;
  loading: boolean;
}) => {
  const COLUMNS_TO_RENDER: BaseTableColumn[] = [
    "dateTime",
    "mailbox",
    "subject",
    "sender",
    "content",
  ];
  
  return (
    <BaseTable 
      columns={COLUMNS_TO_RENDER} 
      data={unprocessedEmails}
      pagination={pagination}
      setPagination={setPagination}
      totalCount={totalCount}
      loading={loading}
    />
  );
};

export default UnprocessedEmailsTable;
